var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"beta-badge"},[_vm._v("[ BETA ]")])
}
var staticRenderFns = []

export { render, staticRenderFns }